{
  "titles": {
    "adminSettings": "Admin Settings"
  },
  "localeSettings": {
    "title": "Language support",
    "description": "List of supported languages for product information translations in the database.",
    "note": "Note: If you add a language, you have to update existing products manually.",
    "tableTitles": {
      "name": "Name",
      "nameInNativeLanguage": "Name in native language",
      "languageTag": "Language tag"
    },
    "defaultLocale": "{{languageName}} - default",
    "placeholders": {
      "name": "Name"
    },
    "links": {
      "addLocale": "Add"
    },
    "icons": {
      "delete": "Delete"
    },
    "deleteLocaleConfirmationDialog": {
      "title": "Delete locale",
      "content": "Are you sure you want to proceed?",
      "buttons": {
        "cancel": "Cancel",
        "delete": "Delete"
      }
    },
    "errors": {
      "createLocale": "Error occurred while adding locale",
      "updateLocale": "Error occurred while updating locale",
      "deleteLocale": "Error occurred while removing locale",
      "fetch": "Error occurred while fetching locales"
    }
  },
  "productCategories": {
    "title": "Product categories",
    "listTitles": {
      "categories": "Categories",
      "subcategories": "Subcategories"
    },
    "description": "List of supported categories in the product database.",
    "warning": "Warning: Removing an existing category will move all products included in the category into category named Uncategorized. These products will not be visible for customers until they are returned back to a proper category.",
    "placeholders": {
      "category": "{{language}} name",
      "subcategory": "{{language}} name",
      "categoryTranslation": "{{language}} translation",
      "subcategoryTranslation": "{{language}} translation"
    },
    "deleteCategoryConfirmationDialog": {
      "title": "Delete category",
      "content": "Deleting a category will remove it and all its subcategories. This always affect all regions. All products under the category will be moved to “Uncategorized”. Are you sure you want to proceed?",
      "buttons": {
        "cancel": "Cancel",
        "delete": "Delete"
      }
    },
    "deleteSubcategoryConfirmationDialog": {
      "title": "Delete subcategory",
      "content": "Are you sure you want to remove the subcategory? This subcategory will be completely deleted.",
      "buttons": {
        "cancel": "Cancel",
        "delete": "Delete"
      }
    },
    "links": {
      "addCategory": "Add",
      "addSubcategory": "Add"
    },
    "errors": {
      "createCategory": "Error occurred while adding category",
      "updateCategory": "Error occurred while updating category",
      "deleteCategory": "Error occurred while removing category",
      "createSubcategory": "Error occurred while adding subcategory",
      "updateSubcategory": "Error occurred while updating subcategory",
      "deleteSubcategory": "Error occurred while removing subcategory",
      "fetch": "Error occurred while fetching categories",
      "nameBlank": "Name must not be blank"
    }
  },
  "properties": {
    "title": "Properties",
    "description": "List of product properties and their possible values.",
    "typeLabel": "Type",
    "valuesLabel": "Values",
    "noValues": "No values defined",
    "noProperties": "No properties found",
    "types": {
      "color": "Color",
      "text": "Text",
      "number": "Number"
    },
    "labels": {
      "valueName": "Color name",
      "valueHex": "HEX code without #"
    },
    "placeholders": {
      "valueName": "e.g. Red",
      "valueHex": "e.g. FF3B11"
    },
    "links": {
      "addColor": "Add color",
      "saveValue": "Save",
      "cancelValue": "Cancel"
    },
    "errors": {
      "fetch": "Error occurred while fetching properties",
      "createValue": "Error occurred while adding property value",
      "invalidHex": "Enter a valid HEX code (e.g. FF3B11)",
      "duplicateName": "A color with this name already exists"
    }
  }
}
